import React from 'react'
import { Box, MenuItem, TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export enum TimeResolution {
  Hour = 'Hour',
  Month = 'Month',
}

type Props = {
  value: TimeResolution
  onChange: (value: TimeResolution) => void
}

export function ChartTimeResolutionSelect({
  value,
  onChange,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <Box width={120}>
      <TextField
        label={t('charts.timeResolution')}
        value={value}
        onChange={(event) => onChange(event.target.value as TimeResolution)}
        select
        variant="outlined"
        disabled
      >
        {Object.values(TimeResolution).map((option) => (
          <MenuItem key={option} value={option}>
            {t(`timeResolution.${option}`)}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  )
}
